module.exports = __webpack_public_path__ + "static/media/Sofia-Pro-Ultra-Light.aabeaeee.ttf";